var map = {
	"./featured-title.de-CH.json": 1070,
	"./featured-title.de-DE.json": 1071,
	"./featured-title.en-CA.json": 1072,
	"./featured-title.en-GB.json": 1073,
	"./featured-title.en-IN.json": 1074,
	"./featured-title.en-ME.json": 1075,
	"./featured-title.en-US.json": 1076,
	"./featured-title.es-EM.json": 1077,
	"./featured-title.es-ES.json": 1078,
	"./featured-title.fr-BE.json": 1079,
	"./featured-title.fr-CA.json": 1080,
	"./featured-title.fr-CH.json": 1081,
	"./featured-title.nl-BE.json": 1082,
	"./featured-title.nl-NL.json": 1083,
	"./featured-title.pl-PL.json": 1084,
	"./featured-title.pt-BR.json": 1085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1069;